import { useParams } from 'react-router-dom';
import { NavBar } from '@design-system/NavBar';
import { useGetSampleDetailsQuery } from '@viome/viome-base/src/usecase/Misc/MiscQuery';
import { SampleDetailsPageCustomerSection } from './SampleDetailsPageCustomerSection';
import { SampleDetailsPageSampleInformationSection } from './SampleDetailsPageSampleInformationSection';
import { SampleDetailsPageLabInformationSection } from './SampleDetailsPageLabInformationSection';

export const SampleDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const { data: samples, isLoading } = useGetSampleDetailsQuery();

  const currentSample = samples?.find(
    (sample) => sample.sample_information.sample_id === id,
  );

  return (
    <section className="page-container page-container flex flex-col gap-12">
      <div className="flex flex-col gap-6 md:gap-12">
        <NavBar
          buttonLabel={<span className="max-md:hidden">All Tests</span>}
        />

        <h1 className="typography-d2 text-primary font-normal">
          {currentSample?.sample_information.test_name}
        </h1>
      </div>

      <SampleDetailsPageCustomerSection sampleId={id} isLoading={isLoading} />

      <SampleDetailsPageSampleInformationSection
        sampleId={id}
        isLoading={isLoading}
      />

      <SampleDetailsPageLabInformationSection
        sampleId={id}
        isLoading={isLoading}
      />

      <div className="text-tertiary flex flex-col gap-4 mb-12">
        <h3>Disclaimer:</h3>
        <p>{currentSample?.disclaimer_text}</p>
        <p>
          {
            `*The information on this report is for educational and informational use only. 
            The information is not intended to be used by the customer for any diagnostic purpose and is not a substitute for professional medical advice. 
            You should always seek the advice of your physician or other health care provider with any questions you may have regarding diagnosis, cure, treatment, mitigation, 
            or prevention of any disease or other medical condition or impairment or the status of your health.`
          }
        </p>
        <p className='my-4'>{'VERSION: 7.2.0'}</p>
      </div>
    </section>
  );
};
